import { TableName } from '@openx/components-table/Table.tsx';
import { type AllTableCriteria, CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { useMemo } from 'react';
import { AD_DURATION_LABELS } from '../components/DealInsightsDelivery/sections/DeliveryByAdDurationTable/utils/adDurationLabels.ts';
import { AD_SIZE_LABELS } from '../components/DealInsightsDelivery/sections/DeliveryByAdSizeTable/utils/adSizeLabels.ts';

const TABLE_PAGE_SIZE = 10;
const AD_SIZE_TABLE_PAGE_SIZE = Object.keys(AD_SIZE_LABELS).length;
const AD_DURATION_TABLE_PAGE_SIZE = Object.keys(AD_DURATION_LABELS).length;

const getGeneralSortableColumns = (): string[] => [
  'deal_name',
  'health_score',
  'impressions',
  'spend',
  'vcr',
  'ctr',
  'ecpm',
  'bid_rate',
  'win_rate',
  'viewability',
  'iqs_on_impression',
];

export const useDefaultCriteria = (): Record<string, AllTableCriteria> => {
  return useMemo(
    () => ({
      [TableName.DEAL_INSIGHTS_GENERAL]: {
        [CriteriaDimension.PAGINATION]: {
          pageNumber: 1,
          pageSize: TABLE_PAGE_SIZE,
          totalCount: 0,
        },
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          direction: SortDirection.DESC,
          sortableColumns: getGeneralSortableColumns(),
        },
      },
      [TableName.DEAL_INSIGHTS_DELIVERY_BY_DOMAIN_BUNDLE]: {
        [CriteriaDimension.PAGINATION]: {
          pageNumber: 1,
          pageSize: TABLE_PAGE_SIZE,
          totalCount: 0,
        },
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          direction: SortDirection.DESC,
          sortableColumns: [
            'domain_bundle',
            'mobileappname',
            'impressions',
            'ctr',
            'ecpm',
            'sov',
            'spend',
            'vcr',
            'viewability',
          ],
        },
      },
      [TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE]: {
        [CriteriaDimension.PAGINATION]: {
          pageNumber: 1,
          pageSize: AD_SIZE_TABLE_PAGE_SIZE,
          totalCount: 0,
        },
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          isServerSortDisabled: true,
          direction: SortDirection.DESC,
          sortableColumns: ['ad_size', 'ctr', 'sov', 'spend', 'ecpm', 'impressions', 'viewability'],
        },
      },
      [TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_DURATION]: {
        [CriteriaDimension.PAGINATION]: {
          pageNumber: 1,
          pageSize: AD_DURATION_TABLE_PAGE_SIZE,
          totalCount: 0,
        },
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          direction: SortDirection.DESC,
          sortableColumns: ['ad_duration', 'impressions', 'spend', 'clicks', 'ctr', 'ecpm', 'sov', 'viewability'],
          isServerSortDisabled: true,
        },
      },
      [TableName.DEAL_INSIGHTS_AUDIENCES]: {
        [CriteriaDimension.PAGINATION]: {
          pageNumber: 1,
          pageSize: TABLE_PAGE_SIZE,
          totalCount: 0,
        },
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          direction: SortDirection.DESC,
          sortableColumns: ['deal_name', 'impressions', 'uniques', 'avg_frequency', 'spend', 'viewability'],
        },
      },
      [TableName.DEAL_INSIGHTS_GEOLOCATION]: {
        [CriteriaDimension.SORT]: {
          column: 'impressions',
          direction: SortDirection.DESC,
          sortableColumns: ['country', 'impressions', 'spend', 'clicks'],
        },
      },
    }),
    []
  );
};
